import { useState } from 'react';
import styled from "@emotion/styled";
import { useRegisterSW } from "virtual:pwa-register/react";

const BannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.spacing(2)};
  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(2)};
  background-color: ${(props) => props.theme.colors.state.informative[1000]};
  color: ${(props) => props.theme.colors.neutral.white};
  font-family: ${(props) => props.theme.typography.body4Bold.fontFamily};
  font-weight: ${(props) => props.theme.typography.body4Bold.fontWeight};
  font-size: ${(props) => props.theme.typography.body4Bold.fontSize};
  line-height: ${(props) => props.theme.typography.body4Bold.lineHeight};
`;

const ActionButton = styled.button`
  border: 1px solid ${(props) => props.theme.colors.neutral.white};
  border-radius: ${(props) => props.theme.shape.borderRadius};
  background: transparent;
  color: ${(props) => props.theme.colors.neutral.white};
  padding: ${(props) => props.theme.spacing(0.5)} ${(props) => props.theme.spacing(1.5)};
  cursor: pointer;
  font-family: ${(props) => props.theme.typography.body4Bold.fontFamily};
  font-weight: ${(props) => props.theme.typography.body4Bold.fontWeight};
  font-size: ${(props) => props.theme.typography.captionBold.fontSize};
`;

const CloseButton = styled.button`
  border: none;
  background: transparent;
  color: ${(props) => props.theme.colors.neutral.white};
  padding: ${(props) => props.theme.spacing(0.5)};
  cursor: pointer;
  font-family: ${(props) => props.theme.typography.body4Bold.fontFamily};
  font-size: ${(props) => props.theme.typography.captionBold.fontSize};
`;

export function ReloadPrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onNeedRefresh: () => {
      // Hook will set needRefresh true internally; we just trigger a re‑render
    },
    onRegisteredSW(swUrl: string, registration?: ServiceWorkerRegistration) {
      if (registration) {
        setInterval(async () => {
          if (registration.installing || !navigator.onLine) return;
          const resp = await fetch(swUrl, { cache: "no-store", headers: { "cache-control": "no-cache" } });
          if (resp.status === 200) {
            await registration.update();
          }
        }, 60 * 60 * 1000);
      }
    },
    onRegisterError(error: Error) {
      console.error("SW registration error:", error);
    },
  });

  const [dismissed, setDismissed] = useState(false);

  if (!needRefresh || dismissed) return null;

  const handleUpdate = async () => {
    await updateServiceWorker(true);
    setNeedRefresh(false);
    setDismissed(true);
  };

  const handleClose = () => {
    setNeedRefresh(false);
    setDismissed(true);
  };

  return (
    <BannerContainer role="alert">
      <span>Nueva versión disponible</span>
      <ActionButton onClick={handleUpdate}>Actualizar</ActionButton>
      <CloseButton onClick={handleClose}>Cerrar</CloseButton>
    </BannerContainer>
  );
}
